/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dark_Flat_Mole_DozeInputs */

const en_dark_flat_mole_doze = /** @type {(inputs: Dark_Flat_Mole_DozeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove manager`)
};

const de_dark_flat_mole_doze = /** @type {(inputs: Dark_Flat_Mole_DozeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manager entfernen`)
};

/**
* | output |
* | --- |
* | "Remove manager" |
*
* @param {Dark_Flat_Mole_DozeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dark_flat_mole_doze = /** @type {((inputs?: Dark_Flat_Mole_DozeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dark_Flat_Mole_DozeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dark_flat_mole_doze(inputs)
	return de_dark_flat_mole_doze(inputs)
});